import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { resetPassword } from '../../redux/actions/authActions'
import { Link, useNavigate, useLocation  } from 'react-router-dom'
import styles from '../../sass/signin.module.scss'
import { Icons, IMG } from '../../constant'
import { toast } from 'react-toastify'

const ResetPassword = () => {
  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { loader } = useSelector((state) => state.admin);
  const [error, setError] = useState(null);

  // Extracting token and email from URL
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get('token');
  const email = searchParams.get('email');

  useEffect(() => {
    if (!token && !email) {
      navigate('/');
    }
  }, [token, email, navigate]);

  const handleResetPassword = () => {
    const data = { token, email, password, password_confirmation: passwordConfirmation };
    console.log('Form data of reset password:', data);

    dispatch(resetPassword(data))
      .unwrap()
      .then(() => {
        toast.success("Success")
        navigate('/success-password');
      })
      .catch((error) => {
        if (error.errors && typeof error.errors === 'object') {
            const errorMessages = Object.values(error.errors).flat(); // Convert errors object to an array of messages
            setError(errorMessages);
        } else {
            setError(error.message || 'Failed to reset password. Please try again.');
        }
      });
  };

  return (
    <div className={styles.AuthSectionContainer}>
      <div className={styles.AuthSectionContainer_body} style={{ backgroundImage: `url(${IMG.authblur})` }}>
        <img src={IMG.logo} className={styles.AuthSectionContainer_logo} alt='logo' />
        <h1 className={styles.AuthSectionContainer_title}>Reset your password</h1>
        <p className={styles.AuthSectionContainer_subtitle}>Enter a new password to secure your account.</p>

        <div className={styles.AuthSectionContainer_password_wrapper}>
          <input
            type={showPassword ? 'text' : 'password'}
            placeholder="Enter a new password"
            className={styles.AuthSectionContainer_form_input}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <div onClick={() => setShowPassword(!showPassword)} className={styles.AuthSectionContainer_password_icon}>
            {showPassword ? <img src={Icons.eyeFrame} alt='eyeFrame' /> : <img src={Icons.eyeSlash} alt='eyeslash' />}
          </div>
        </div>
        <div className={styles.AuthSectionContainer_password_wrapper}>
          <input
            type={showPassword ? 'text' : 'password'}
            placeholder="Confirm your new password"
            className={styles.AuthSectionContainer_form_input}
            value={passwordConfirmation}
            onChange={(e) => setPasswordConfirmation(e.target.value)}
          />
        </div>
       
        {loader ? (
          <button
            className={styles.ActionButton_fill}
            disabled
          >
            Please wait...
          </button>
        ) : (
          <button
            onClick={handleResetPassword}
            className={styles.ActionButton_fill}
          >
            Update Password
          </button>
        )}

        {error && (
        <div className={styles.AuthSectionContainer_errors}>
            {Array.isArray(error)
            ? error.map((errMsg, index) => <div key={index}>{errMsg}</div>)
            : error}
        </div>
        )}

        <div className={styles.AuthSectionContainer_footer}>
          <Link to='/login' className={styles.AuthSectionContainer_link}>↩&nbsp;&nbsp;Back to Login</Link>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
